module.exports = __webpack_public_path__ + "img/c6dca81.png";